import {
  IT_VIEW_ACTION_BAR_CONTROLLER,
  IViewActionBarController,
  MK_VIEW_ACTION_BAR
} from "../_controllers/IViewActionBarController";
import {Component} from "@angular/core";
import {ViewActionBarModel} from "../_models/ViewActionBarModel";
import {AbstractView} from "../../../views/AbstractView";

@Component({
  selector: 'link-view-action-bar',
  templateUrl: './view-action-bar.view.html',
  styleUrls: ['./view-action-bar.view.scss'],
})
export class ViewActionBarView extends AbstractView<IViewActionBarController> {

  protected readonly model: ViewActionBarModel;

  constructor() {
    super(IT_VIEW_ACTION_BAR_CONTROLLER);

    this.model = this.getController().getModel(MK_VIEW_ACTION_BAR);
  }

  protected actionClicked(actionName?: string) {
    if(actionName) {
      this.getController().handle(actionName, {itemName: actionName});
    }
  }
}
